function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (theme, _ref) {
  var getTextStyle = _ref.getTextStyle;
  return {
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
          type = _ref2.type,
          variant = _ref2.variant,
          textStyle = _ref2.textStyle;

      switch (targetElement) {
        case "list":
          {
            return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
              margin: 0,
              listStyleType: "none"
            }, type === "unordered" && {
              paddingLeft: "1.25em"
            }), type === "ordered" && {
              counterReset: "ordered",
              paddingLeft: "1.25em"
            }), type === "steps" && {
              counterReset: "steps",
              padding: "0.25em 0 0.25em 2.5em"
            }), getTextStyle({
              name: textStyle,
              mode: "container"
            })), {}, {
              color: theme.colors.black
            });
          }

        case "item":
          {
            switch (type) {
              case "unordered":
                {
                  return {
                    position: "relative",
                    ":not(:first-of-type)": {
                      marginTop: textStyle === "subtitle1" ? theme.space[4] : textStyle === "subtitle2" ? theme.space[3] : theme.space[2]
                    },
                    "::before": {
                      content: '""',
                      width: "0.5em",
                      height: "0.5em",
                      borderRadius: theme.radii[3],
                      position: "absolute",
                      top: "0.5em",
                      left: "-1.25em",
                      backgroundColor: variant === "danger" ? theme.colors.conditional.negative.graphics : theme.colors.secondary.lightBlue.t100
                    },
                    "& ul, & ol": {
                      marginTop: "0.5em"
                    },
                    "&:not(:last-of-type) ul, &:not(:last-of-type) ol": {
                      marginBottom: "1em"
                    }
                  };
                }

              case "ordered":
                {
                  return {
                    position: "relative",
                    counterIncrement: "ordered",
                    ":not(:first-of-type)": {
                      marginTop: textStyle === "subtitle1" ? theme.space[4] : textStyle === "subtitle2" ? theme.space[3] : theme.space[2]
                    },
                    "::before": {
                      content: 'counter(ordered, decimal) ". "',
                      position: "absolute",
                      top: 0,
                      left: "-1.25em"
                    },
                    "& ul, & ol": {
                      marginTop: "0.5em"
                    },
                    "&:not(:last-of-type) ul, &:not(:last-of-type) ol": {
                      marginBottom: "1em"
                    },
                    "& ol li::before": {
                      content: 'counter(ordered, lower-alpha) ". "'
                    },
                    "& ol ol li::before": {
                      content: 'counter(ordered, lower-roman) ". "'
                    }
                  };
                }

              case "steps":
                {
                  return {
                    position: "relative",
                    counterIncrement: "steps",
                    marginBottom: "1.4em",
                    ":last-of-type": {
                      marginBottom: 0
                    },
                    "::before": {
                      content: "counter(steps, decimal)",
                      width: "2em",
                      height: "2em",
                      lineHeight: "2em",
                      color: theme.colors.white,
                      backgroundColor: theme.colors.primary.blue.t100,
                      fontWeight: theme.fontWeights.medium,
                      textAlign: "center",
                      borderRadius: theme.radii[3],
                      position: "absolute",
                      top: "-0.25em",
                      left: "-2.5em"
                    },
                    "& ul, & ol": {
                      marginTop: "1em"
                    },
                    "&:not(:last-of-type) ul, &:not(:last-of-type) ol": {
                      marginBottom: "1.25em"
                    },
                    "& ol li::before": {
                      content: "counter(steps, lower-alpha)",
                      color: theme.colors.black,
                      backgroundColor: theme.colors.secondary.lightBlue.t100
                    }
                  };
                }

              default:
                {
                  return null;
                }
            }
          }

        default:
          {
            return null;
          }
      }
    }
  };
});